import { type ButtonHTMLAttributes, forwardRef } from 'react'
import clsx from 'clsx'

type ButtonVariant = 'primary' | 'secondary' | 'danger'
type ButtonSize = 'sm' | 'md' | 'lg'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  isLoading?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant = 'primary', size = 'md', isLoading = false, disabled, children, ...props },
  ref,
) {
  const base =
    'inline-flex items-center justify-center rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'

  const variantClass =
    variant === 'primary'
      ? 'bg-primary-600 hover:bg-primary-700 text-white'
      : variant === 'secondary'
        ? 'bg-brand-parchment hover:bg-brand-parchment/80 text-secondary-900'
        : 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500'

  const sizeClass =
    size === 'sm'
      ? 'px-3 py-2 text-sm font-semibold'
      : size === 'lg'
        ? 'px-5 py-3 text-button font-bold'
        : 'px-4 py-2 text-sm font-semibold'

  return (
    <button
      ref={ref}
      className={clsx(base, variantClass, sizeClass, className)}
      disabled={disabled || isLoading}
      {...props}
    >
      {children}
    </button>
  )
})


